import PropTypes from 'prop-types';
import ItemsInOrderTablePartName from '../ItemsInOrderTablePartName';
import { ItemGADetailsPropTypes } from '@app/components/pages/checkout/order-confirmation/declarations.proptypes';

const ItemsInOrderTablePartDescription = ({
  name,
  nonReturnablePartNumber,
  remanPartNumber,
  ssroBundle,
  prop65Warning,
  unitWeight,
  productDisplayUrl,
  itemGADetails,
  listName
}) => (
  <div className="text-md">
    <div className="d-flex">
      <ItemsInOrderTablePartName
        name={name}
        nonReturnablePartNumber={nonReturnablePartNumber}
        prop65Warning={prop65Warning}
        remanPartNumber={remanPartNumber}
        ssroBundle={ssroBundle}
        unitWeight={unitWeight}
        productDisplayUrl={productDisplayUrl}
        itemGADetails={itemGADetails}
        listName={listName}
      />
    </div>
  </div>
);

ItemsInOrderTablePartDescription.propTypes = {
  name: PropTypes.string.isRequired,
  nonReturnablePartNumber: PropTypes.bool,
  prop65Warning: PropTypes.string,
  remanPartNumber: PropTypes.bool,
  ssroBundle: PropTypes.arrayOf(
    PropTypes.shape({
      selfServiceOptionId: PropTypes.string,
      selfServiceOptionName: PropTypes.string
    })
  ),
  unitWeight: PropTypes.string,
  productDisplayUrl: PropTypes.string,
  itemGADetails: ItemGADetailsPropTypes,
  listName: PropTypes.string
};

export default ItemsInOrderTablePartDescription;
